interface IQuarterlyData {
  sobValues: (number | null | undefined)[]
  ndpValues: (number | null | undefined)[]
}

export const calculateWeightAverage = ({ sobValues, ndpValues }: IQuarterlyData) => {
  let numerator = 0
  let denominator = 0

  for (let i = 0; i < sobValues.length; i++) {
    if (sobValues[i] && ndpValues[i]) {
      numerator += sobValues[i]! * ndpValues[i]!
      denominator += ndpValues[i]!
    }
  }

  if (denominator === 0) {
    return 0
  }

  return numerator / denominator
}
